// extracted by mini-css-extract-plugin
export default {"btn_container":"GrabBitBtn_btn_container__EAf4k","btn":"GrabBitBtn_btn__D6Ybx","img":"GrabBitBtn_img__TfDFR"};